import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import FAQ from './components/FAQ';
import AboutUs from './components/AboutUs';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Testimonials from './components/Testimonials';

// Importando a página de links
import LinksPage from '@/pages/LinksPage';

// Componente para rolagem suave ao topo
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Implementação de rolagem suave usando behavior: "smooth"
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }, [pathname]);

  return null;
};

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            <div className="font-body">
              <Header />
              <Hero />
              <Services />
              <FAQ />
              <Testimonials />
              <AboutUs />
              <Footer />
              <WhatsAppButton />
            </div>
          }
        />
        <Route path="/links" element={<LinksPage />} />
        {/* Rota de fallback para o Netlify */}
        <Route path="*" element={<div>Página não encontrada</div>} />
      </Routes>
    </>
  );
}

export default App;